import { render, staticRenderFns } from "./PlayerSpinner.vue?vue&type=template&id=78dc26f8&scoped=true"
var script = {}
import style0 from "./PlayerSpinner.vue?vue&type=style&index=0&id=78dc26f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc26f8",
  null
  
)

export default component.exports